"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var Metadata = function Metadata(_ref) {
  var categoriesCount = _ref.categoriesCount,
      totalTopicCount = _ref.totalTopicCount;
  return (0, _preact.h)("ul", {
    className: "list--dot-seperated community-category__card-metadata"
  }, categoriesCount !== undefined && (0, _preact.h)("li", {
    className: "qa-forum-overview-category-counter"
  }, categoriesCount, " ", (0, _preact.h)(_phrase.default, {
    m: "Forum",
    p: "knowledgebase.category",
    count: {
      n: categoriesCount.toString()
    }
  })), totalTopicCount !== undefined && (0, _preact.h)("li", {
    className: "qa-forum-overview-topic-counter"
  }, (0, _preact.h)(_phrase.default, {
    m: "Forum",
    p: "forumList.meta.counter.topic",
    count: {
      n: totalTopicCount.toString()
    }
  })));
};

var _default = Metadata;
exports.default = _default;